import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownComponent } from '@ui-kit/form/dropdown/dropdown.component';
import { DividerModule } from 'primeng/divider';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { Pagination } from './pagination.interface';

@Component({
    selector: 'paginator',
    standalone: true,
    imports: [PaginatorModule, TranslateModule, ReactiveFormsModule, DropdownComponent, DividerModule],
    templateUrl: './paginator.component.html',
    styleUrl: './paginator.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginatorComponent {
    id = input.required<string>();
    pagination = input.required<Pagination>();
    totalCount = input.required<number>();
    pageSizeOptions = input<number[]>([]);
    includeDivider = input<boolean>(true);
    onPageChange = output<Pagination>();

    changePage(pageOptions: PaginatorState): void {
        if (pageOptions.page === undefined || pageOptions.rows === undefined) {
            return;
        }

        this.onPageChange.emit({ skip: pageOptions.page, take: pageOptions.rows });
    }

    changePageSize(): void {
        this.onPageChange.emit({ skip: 0, take: this.pagination().take });
    }
}
